import { render } from "./HeroiconsSolidDeviceMobile.vue?vue&type=template&id=700978a7"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDeviceMobile.vue"]])

export default __exports__